import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import styled from 'styled-components/macro';

import { Grid } from 'components';
import { HighlightedColor } from 'App/types';

const DetailsIcon = styled(Grid)<{ $color: string }>`
  svg {
    color: ${({ $color }) => $color};
  }
`;

const Value = styled(Typography)<{
  $colorText?: boolean;
  appearance: HighlightedColor;
}>`
  margin-left: 4px;
  color: ${({
    theme: {
      palette: {
        custom: {
          list: { highlightedData, darkText },
        },
      },
    },
    $colorText,
    appearance,
  }) => {
    if ($colorText) return highlightedData[appearance];
    if (appearance === HighlightedColor.BLACK) return darkText;
    return darkText;
  }};
`;

const Information = styled(Typography)`
  margin-top: 4px;
  text-align: left;
  color: ${({
    theme: {
      palette: {
        custom: {
          list: { lightGreyText },
        },
      },
    },
  }) => lightGreyText};

  white-space: nowrap;
`;

const Title = styled(Typography)`
  text-transform: capitalize;
  text-align: left;
  color: ${({
    theme: {
      palette: {
        text: { primary },
      },
    },
  }) => primary};
`;

const IconWrapper = styled.div`
  transform: rotate(0deg);
  svg {
    width: 16px;
    height: 16px;
    path {
      stroke: ${({ theme }) => `${theme.palette.grey[400]}`};
    }
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => `${theme.palette.grey[400]}`};
`;

export const BasicListItemStyles = {
  DetailsIcon,
  IconWrapper,
  Information,
  Link: StyledLink,
  Title,
  Value,
};
